export const backgroundColors = [
  "rgb(255, 99, 132)",
  "rgb(75, 192, 192)",
  "rgb(53, 162, 235)",
];

export const timeFormatMillSec = "YYYY-MM-DD HH:mm:ss.SSS";
export const timeFormatSec = "YYYY-MM-DD HH:mm:ss";
